import { cva } from "class-variance-authority";
import type { ComponentPropsWithoutRef, PropsWithChildren } from "react";

import { Text } from "../Typography/Text";

import Icon from "./Icon";

const badgeStyles = cva("", {
  variants: {
    type: {
      primary: "bg-[#1D2445]",
      neutral: "bg-[#E0E0E3]",
      check: "bg-[#DDF3E4]",
      error: "bg-[#641723]",
    },
  },
  defaultVariants: {
    type: "primary",
  },
});

type BaseProps = PropsWithChildren<{
  count?: number;
  type?: "primary" | "neutral" | "check" | "error";
}>;

type BadgeIconProps = Omit<ComponentPropsWithoutRef<"span">, keyof BaseProps> &
  BaseProps;

export const BadgeIcon: React.FC<BadgeIconProps> = ({
  count,
  type = "primary",
  className,
  ...props
}) => {
  const wrapperClasses = badgeStyles({ type });

  return (
    <span
      {...props}
      className={`${wrapperClasses} ${className}  flex h-[20px] w-[20px] items-center justify-center rounded-full`}
    >
      {(type === "primary" || type === "neutral") && (
        <Text
          variant="label"
          className={
            type === "neutral" ? "text-muted-foreground" : "text-white"
          }
        >
          {count}
        </Text>
      )}

      {type === "check" && <Icon iconName="Check" />}

      {type === "error" && (
        <Text variant="label" className="text-white">
          !
        </Text>
      )}
    </span>
  );
};
